import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import { isEmpty } from "lodash";
import { getSubscriptions } from "domain/subscriptions/api/get-subscriptions";
import { SubscriptionsRequestDto } from "domain/subscriptions/entities/dtos/subscriptions-request.dto";

export const getSubscriptionsAction = createAsyncThunk(
  "subscriptions/getSubscriptionsAction",
  async ({ accountId, objectId }: SubscriptionsRequestDto) => {
    try {
      if (isEmpty(accountId)) {
        toast.error("Kindly first select an account from the drawer.");
        return;
      }

      return await getSubscriptions({ accountId, objectId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
